import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState(() => localStorage.getItem('lastLoginEmail') || '');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      localStorage.setItem('lastLoginEmail', email);
      navigate('/dashboard');
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (err.response?.status === 429 && typeof detail === 'string') {
        setError(detail);
      } else {
        setError('Email o contrasena incorrectos.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background"></div>
      <div className="login-overlay"></div>

      <div className="login-card">
        <div className="login-header">
          <div className="login-brand">Kontinuos</div>
          <h1 data-testid="login-title">Acceso interno</h1>
          <p data-testid="login-subtitle">Gestion de imprenta</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form" data-testid="login-form">
          {error && (
            <div className="login-error" data-testid="login-error">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-input"
              placeholder="usuario@imprenta.com"
              required
              disabled={loading}
              autoComplete="username"
              data-testid="login-email-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Contrasena
            </label>
            <div className="password-input-row">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                placeholder="Contrasena"
                required
                disabled={loading}
                autoComplete="current-password"
                data-testid="login-password-input"
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(current => !current)}
                disabled={loading}
              >
                {showPassword ? 'Ocultar' : 'Ver'}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
            data-testid="login-submit-button"
          >
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>

        <p className="login-security-note">
          Acceso exclusivo para personal autorizado.
        </p>
      </div>
    </div>
  );
};

export default Login;
